import { GenericActivityListSort } from 'src/models/genericActivityList';
import { IdoLinkingsParameter, ReferencedIdo } from 'src/models/ido';
import { AbstractQuery } from 'src/models/query';

export { GetTheChangelogForAnIdoAndInstanceQuery } from './GetTheChangelogForAnIdoAndInstanceQuery';
export { GetTheIdoButtonForAnAggregateIdQuery } from './GetTheIdoButtonForAnAggregateIdQuery';

export class GetTheIdoJSONModelForAnIdoAndInstanceQuery extends AbstractQuery {
	apiVersion = 2;
	name = 'IFS_IDO_Query_Queries_GetTheIdoJSONModelForAnIdoAndInstanceQuery';
	sort = [];

	constructor(
		idoId: number | string,
		idoInstanceId: number,
		baseUrlOfTheClassicVersion: string,
		masterDataExtJSTabTitle: string,
		pongId: string,
		referencedIdo: ReferencedIdo | null = null
	) {
		super();

		this.parameters.push({ idoId: idoId });

		this.parameters.push({ idoInstanceId: idoInstanceId });

		this.parameters.push({
			baseUrlOfTheClassicVersion: baseUrlOfTheClassicVersion,
		});

		this.parameters.push({
			masterDataExtJSTabTitle: masterDataExtJSTabTitle,
		});

		this.parameters.push({ pongId: pongId });

		if (referencedIdo !== null) {
			this.parameters.push({ referencedIdo });
		}

		if (idoId === '') {
			this.subscribeForUpdates = false;
		}
	}
}

export class GetTheIdoMasterDataFieldValuesForAnIdoAndInstanceQuery extends AbstractQuery {
	cacheable = false;
	ignoreCachedResult = true;
	name = 'IFS_IDO_Query_Queries_GetTheIdoMasterDataFieldValuesForAnIdoAndInstanceQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor(idoId: number, idoInstanceId: number) {
		super();

		this.parameters.push({ idoId: idoId });
		this.parameters.push({ idoInstanceId: idoInstanceId });
	}
}

export class GetTheIdoButtonSearchResultsQuery extends AbstractQuery {
	name = 'IFS_IDO_Query_Queries_GetTheIdoButtonSearchResultsQuery';
	sort = [];
	subscribeForUpdates = false;
	private readonly aggregateId: string;

	constructor(query: string, aggregateId: string) {
		super();
		this.aggregateId = aggregateId;
		this.parameters.push({ query: query });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}

	uniqueQueryIdentifier(): string {
		return this.createStableIdentifier({
			aggregateId: this.aggregateId,
		});
	}
}

export class GetThePhoneCallCallerNameForAnIdoAndInstanceQuery extends AbstractQuery {
	name = 'IFS_IDO_Query_Queries_GetThePhoneCallCallerNameForAnIdoAndInstanceQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor(idoId: number, idoInstanceId: number, callerNumber: string) {
		super();
		this.parameters.push({ idoId: idoId });
		this.parameters.push({ idoInstanceId: idoInstanceId });
		this.parameters.push({ callerNumber: callerNumber });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetThePhoneCallCallerNameForAContactPersonInAnIdoAndInstanceQuery extends AbstractQuery {
	name = 'IFS_IDO_Query_Queries_GetThePhoneCallCallerNameForAContactPersonInAnIdoAndInstanceQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor(idoId: number, idoInstanceId: number, contactPersonId: number, callerNumber: string) {
		super();
		this.parameters.push({ idoId: idoId });
		this.parameters.push({ idoInstanceId: idoInstanceId });
		this.parameters.push({ contactPersonId: contactPersonId });
		this.parameters.push({ callerNumber: callerNumber });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetTheIdoRelationsForAnIdoQuery extends AbstractQuery {
	name = 'IFS_IDO_Query_Queries_GetTheIdoRelationsForAnIdoQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor(idoId: number, idoInstanceId: number) {
		super();
		this.parameters.push({ idoId: idoId });
		this.parameters.push({ idoInstanceId: idoInstanceId });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}

export class GetTheIdoRelationsListviewModelAndDataQuery extends AbstractQuery {
	cacheable = true;
	name = 'IFS_IDO_Query_Queries_GetTheIdoListviewModelAndDataQuery';

	constructor(
		idoLinkingsParameter: IdoLinkingsParameter,
		idoInstanceId: string,
		page: number,
		limit: number,
		sort: Array<GenericActivityListSort> = []
	) {
		super();

		this.parameters.push({ idoInstanceId: idoInstanceId });
		this.parameters.push({ idoLink: idoLinkingsParameter });

		this.page = page;
		this.limit = limit;
		this.sort = sort;
	}

	uniqueQueryIdentifier(): string {
		return this.createStableIdentifier();
	}
}
